module.exports = __webpack_public_path__ + "img/fss-demo-main-400x300.c6280663.jpg";